export class PaginatorHelper {
	constructor(
		public size = 10,
		public page = 0,
		public sort = 'id,DESC',
		public totalElements = 0,
		public totalPages = 0,
	) {
	}
}

export class ParamPageable {
	constructor(
		public size: number,
		public page: number,
		public sort: string
	) {
	}
}

